module.exports = __webpack_public_path__ + "static/media/50_000_WAX.9fe39e96.webp";